import RouteBreadcrumbs from './RouteBreadcrumbs'

export default RouteBreadcrumbs
